import { call, put, take, all } from "redux-saga/effects";
import {
  ACCEPT_TEST,
  FETCH_TESTS,
  FETCH_TESTS_EN_CURSO,
  GET_INVITATION_BY_ID,
  GET_QUESTIONNAIRE_PAGE,
  INFORM_PROBLEM,
  PATCH_QUESTIONNAIRE_PAGE,
  SET_INVITATION_BY_ID,
  SET_QUESTIONNAIRE_PAGE,
  SET_TESTS,
  SET_TESTS_EN_CURSO
} from "../actions/sagaActions";
import getAxios from "../getAxios";
import localForage from "localforage";
import { SET_LOADING_VALUE } from "../actions/networkActions";
import { delay, fork } from "@redux-saga/core/effects";

const acceptTestSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(ACCEPT_TEST);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const response = yield ax.post(
        `${process.env.REACT_APP_API_URL}invitations/${payload.id}/accept/`
      );
      console.log("response", response);
    } catch (e) {}
  }
};

const fetchTests = function*() {
  while (true) {
    try {
      const { payload } = yield take(FETCH_TESTS);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const { data } = yield ax.get(
        `${process.env.REACT_APP_API_URL}invitations/?page=${payload.page}`
      );
      let nextInvitations = yield all(
        data.results.map(r => {
          return call(getProject, r);
        })
      );
      nextInvitations = yield setProjectTypeAndService(nextInvitations);
      nextInvitations = yield all(
        nextInvitations.map(inv => setMedicalVisits(inv))
      );
      yield put({
        type: SET_TESTS,
        payload: {
          data: {
            ...data,
            results: nextInvitations
          },
          page: payload.page
        }
      });
    } catch (e) {}
  }
};

const fetchTestsEnCursoSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(FETCH_TESTS_EN_CURSO);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const { data } = yield ax.get(
        `${process.env.REACT_APP_API_URL}invitations/?type=test_en_curso&page=${payload.page}`
      );
      let nextInvitations = yield all(
        data.results.map(r => {
          return call(getProject, r);
        })
      );
      nextInvitations = yield setProjectTypeAndService(nextInvitations);
      nextInvitations = yield all(
        nextInvitations.map(inv => setMedicalVisits(inv))
      );
      yield put({
        type: SET_TESTS_EN_CURSO,
        payload: {
          data: {
            ...data,
            results: nextInvitations
          },
          page: payload.page
        }
      });
    } catch (e) {}
  }
};

const setProjectTypeAndService = function*(nextInvitations) {
  const { token } = yield localForage.getItem("account");
  const ax = yield getAxios(token);
  const servicesResponse = yield ax.get(
    `${process.env.REACT_APP_API_URL}services/`
  );
  const services = servicesResponse.data.results;
  return nextInvitations.map(inv => {
    if (inv.project && inv.project.service && inv.project.project_type) {
      inv.project.project_type = services
        .find(s => s.id === inv.project.service)
        .project_types.find(p => p.id === inv.project.project_type);
      inv.project.service = services.find(s => s.id === inv.project.service);
    }
    return inv;
  });
};

const setMedicalVisits = function*(inv) {
  try {
    const { token } = yield localForage.getItem("account");
    const ax = yield getAxios(token);
    const visits = Array.isArray(inv.project.medical_visits)
      ? yield all(
          inv.project.medical_visits.map(visit =>
            ax.get(`${process.env.REACT_APP_API_URL}medical_visits/${visit}`)
          )
        )
      : [];
    inv.project.medical_visits =
      visits.length > 0 ? visits.map(visit => visit.data) : [];
    return inv;
  } catch (e) {}
};

const getProject = function*(invitation) {
  const { token } = yield localForage.getItem("account");
  const ax = yield getAxios(token);
  const { data } = yield ax.get(
    `${process.env.REACT_APP_API_URL}projects/${invitation.project}`
  );
  return {
    ...invitation,
    project: {
      ...data
    }
  };
};

const getFullDataProject = function*(invitation) {
  const { token } = yield localForage.getItem("account");
  const ax = yield getAxios(token);
  const { data } = yield ax.get(
    `${process.env.REACT_APP_API_URL}projects/${invitation.project}`
  );
  let nextVisits = yield all(
    data.medical_visits.map(visit =>
      ax.get(`${process.env.REACT_APP_API_URL}medical_visits/${visit}`)
    )
  );
  nextVisits = nextVisits.map(visit => visit.data);
  return {
    ...invitation,
    project: {
      ...data,
      questionnaires: yield getQuestionnaires(data.questionnaires),
      products: yield getProducts(data.products),
      medical_visits: nextVisits
    }
  };
};

const getQuestionnaires = function*(questionnaires) {
  try {
    const { token } = yield localForage.getItem("account");
    const ax = yield getAxios(token);
    const nextQuestionnaires = yield all(
      questionnaires.map(questionnaire =>
        ax.get(
          `${process.env.REACT_APP_API_URL}questionnaires/${questionnaire}`
        )
      )
    );
    return nextQuestionnaires.map(q => q.data);
  } catch (e) {}
};

const getProducts = function*(products) {
  const { token } = yield localForage.getItem("account");
  const ax = yield getAxios(token);
  const nextProducts = yield all(
    products.map(product =>
      ax.get(`${process.env.REACT_APP_API_URL}products/${product}`)
    )
  );
  return nextProducts.map(p => p.data);
};

const patchQuestionnairePageSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(PATCH_QUESTIONNAIRE_PAGE);

      yield put({
        type: SET_LOADING_VALUE,
        payload: {
          target: "questionnaire_pages",
          id: payload.id,
          loading: true,
          saved: false
        }
      });

      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const patchResult = yield ax.patch(
        `${process.env.REACT_APP_API_URL}questionnaire_pages/${payload.id}/`,
        payload
      );
      console.log("patchResult", patchResult);
      if (patchResult.status === 200) {
        yield put({
          type: GET_INVITATION_BY_ID,
          payload: { id: payload.invitation }
        });
        yield put({
          type: SET_LOADING_VALUE,
          payload: {
            target: "questionnaire_pages",
            id: payload.id,
            loading: false,
            saved: true
          }
        });
        yield delay(3000);
        yield put({
          type: SET_LOADING_VALUE,
          payload: {
            target: "questionnaire_pages",
            id: payload.id,
            loading: false,
            saved: false
          }
        });
      }
    } catch (e) {}
  }
};

const getInvitationByIdSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(GET_INVITATION_BY_ID);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const { data } = yield ax.get(
        `${process.env.REACT_APP_API_URL}invitations/${payload.id}`
      );
      let nextInvitation = { ...data };
      nextInvitation = yield getFullDataProject(nextInvitation);
      yield put({
        type: SET_INVITATION_BY_ID,
        payload: nextInvitation
      });
    } catch (e) {}
  }
};

const getQuestionnairePageSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(GET_QUESTIONNAIRE_PAGE);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const { data } = yield ax.get(
        `${process.env.REACT_APP_API_URL}questionnaire_pages/${payload.id}`
      );
      yield put({
        type: SET_QUESTIONNAIRE_PAGE,
        payload: data
      });
    } catch (e) {
      // TODO catch e
      console.log("getQuestionnairePageSaga", e);
    }
  }
};

const informProblemSaga = function*() {
  while (true) {
    try {
      const { payload } = yield take(INFORM_PROBLEM);
      const { token } = yield localForage.getItem("account");
      const ax = yield getAxios(token);
      const { data } = yield ax.post(
        `${process.env.REACT_APP_API_URL}reports/`,
        payload.data
      );
    } catch (e) {}
  }
};

export default function*() {
  yield all([
    fetchTests(),
    acceptTestSaga(),
    fetchTestsEnCursoSaga(),
    patchQuestionnairePageSaga(),
    getInvitationByIdSaga(),
    getQuestionnairePageSaga(),
    informProblemSaga()
  ]);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/tests-sagas.js